<template>
  <div class="max-box">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(e,i) in backimgList" style="    background-size: cover;background-position: center;"
       :style="{backgroundImage: `url(${e}?x-oss-process=image/resize,w_1080)`}" :key="i">
        <!-- <van-image class="wh100" :src="e" /> -->
      </van-swipe-item>
      <van-swipe-item v-if="backimgList.length==0">
        <van-image class="wh100" src="" />
      </van-swipe-item>
    </van-swipe>
    <div class="tab-box flex_c_m">
      <div class="tab-item tab-item-one flex_c_m">
        <div class="top-tile flex_c_m">
          <b>{{zhutiInfo.userNum||'0'}}</b>
          <span>人</span>
        </div>
        <div class="down-info flex_c_m">累计参与</div>
      </div>
      <div class="tab-item tab-item-two flex_c_m">
        <div class="top-tile flex_c_m">
          <b>{{zhutiInfo.num||'0'}}</b>
          <span>票</span>
        </div>
        <div class="down-info flex_c_m">累计投票</div>
      </div>
      <div @click="shaerfind" class="tab-item flex_c_m">
        <div class="top-tile top-tile-icon"></div>
        <div class="down-info">分享给朋友</div>
      </div>
    </div>
    <div class="infotext-box">{{zhutiInfo.description||''}}</div>
    <VoteItem 
      v-for="(e,i) in voteList" 
      :key="i" 
      :item="e" 
      :index="i"
      :info="zhutiInfo"
      @onSuccess="voteBack"
    />

    <!-- <div class="back-box" @click="back()"><img class="back" src="../../assets/images/activity/back.png" alt=""></div> -->
  </div>
</template>

<script>
import VoteItem from './page/VoteItem'
import {
  wxTools
} from '@utils'
export default {
  data(){
    return{
      zhutiInfo:{},
      voteList:[],
      backimgList:[],
    }
  },
  components:{
    VoteItem
  },
  created() {
    let token = localStorage.getItem('token')
    if (!token) {
      if (this.$route.query.code) {
        this.$api.user.getWxUser({
					code: this.$route.query.code
				}, res => {
					if(res.data && res.data.token && res.data.token != 'undefined'){
						localStorage.setItem('token', res.data.token)
					}
				})
      } else {
        new wxTools().getCode({
          securityUrl: window.location.href,
          state: ''
        })
      }
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    back(){
      this.$router.push({path:'/'})
    },
    init(){
    
      this.getZhutiDetail();
    },
    // 获取投票列表
    getVoteList(voteId){
      let param = {
        voteId:voteId,
        pageNum:1,
        pageSize:1000
      }
      this.$api.lineVote.getVoteList(param,res=>{
        this.voteList = res.rows;
      })
    },
    // 获取主题详情
    getZhutiDetail(){
      this.$api.lineVote.getZhutiDetail({code:this.$route.query.voteCode},res=>{
        this.zhutiInfo = res.data;
        document.title = res.data.title
        console.log(document.title)
        this.backimgList = res.data.shufflingUrl?res.data.shufflingUrl.split(','):[];
		    this.getVoteList(res.data.id);
      })
    },
    // 投一票回调
    voteBack(e){
      this.voteList[e.index].num = e.num;
    },
    // 分享给朋友
    shaerfind(){
      this.$toast('请点击右上角分享');
    },
  }
}
</script>

<style lang="scss" scoped>
.max-box{
  background-color: #F7F7F7;
  padding-bottom: 50px;
}
.my-swipe .van-swipe-item {
  height: 250px;
}
.tab-box{
  height: 60px;
  border-bottom: solid 1px #D8D8D8;
  background-color: #fff;
  .tab-item{
    height: 100%;
    width: 33.33%;
    flex-wrap: wrap;
    text-align: center;
    border-right: solid 1px #D8D8D8;
    align-content: center;
    .top-tile{
      width: 100%;
      height: 20px;
      margin-bottom: 2px;
      b{
        font-size: 14px;
        color: #38C7B4;
        padding-left: 15px;
      }
      span{
        font-size: 12px;
        color: #D8D8D8;
      }
    }
    .down-info{
      text-align: center;
      width: 100%;
      height: 20px;
      color: #666;
      font-size: 14px;
      padding-left: 15px;
    }
    .top-tile-icon{
      height: 32px;
      background: url('~@assets/images/icon/Path.png') no-repeat center center;
      background-size: 18px 15px;
    }
  }
  .tab-item-one{
    background: url('~@assets/images/icon/Combined Shape.png') no-repeat 10px center;
    background-size: 22px 16px;
  }
  .tab-item-two{
    background: url('~@assets/images/icon/Combined Shape (1).png') no-repeat 10px center;
    background-size: 19px 19px;
  }
}
.infotext-box{
  background-color: #fff;
  padding:15px;
  font-size:14px;
  color: #666;
  margin-bottom: 10px;
}

.back-box {
  position: fixed;
  right: 2px;
  bottom: 20px;
  display: inline-block;
  text-align: right;
  border-radius: 10px
}
.back {
  width: 38px;
  height: auto;
}
</style>